import * as THREE from 'three'
import Experience from "../Experience"
import { gsap } from 'gsap/gsap-core'




const particlesFragmentShader = `varying vec3 vColor;

void main()
{
    gl_FragColor =  vec4(vColor, 1.0);
    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}`

const particlesVertexShader = `
uniform vec2 uResolution;
uniform float uSize;
uniform float uProgress;


uniform vec3 uColorA;

attribute vec3 aPositionTarget;
uniform float aSize;

varying vec3 vColor;

void main()
{



    vec3 mixedPosition = mix(position, aPositionTarget, uProgress);
    

    // Final position
    vec4 modelPosition = modelMatrix * vec4(mixedPosition, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;

    gl_PointSize = 0.0025 * uResolution.y * aSize;
    
    vColor = uColorA;
}`

import ImageWorker from './ImageWorker'



export default class Country {
    constructor() {

        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.intManager = this.experience.interactionManager

        this.sizes = this.experience.sizes
        this.debug = this.experience.debug
        this.workerFlat = new Worker('./assets/vendor/imageWorker_flat1.js');


        this.group = new THREE.Group();
        this.scene.add(this.group)

        this.scaleTl = gsap.timeline({paused: true})
        this.meshes = []



        this.imageCanvas = document.createElement('canvas');
        this.imageCanvas.width = 360;
        this.imageCanvas.height = 180;
        this.context = this.imageCanvas.getContext('2d', { willReadFrequently: true });

        this.regions = this.experience.regions.map(re => re.reshort)


        const verticesCount = 1000 * 3
        const positions = new Float32Array(verticesCount * 3)

        for (let i = 0; i < verticesCount * 3; i++) {
            
            if(i % 3 === 0){
                positions[i] = (Math.random() - 0.5) * 200
            } else if( i % 3 === 1) {
                positions[i] = Math.random() * 10 + 30
                // positions[i] = (Math.random() - 0.5) * 200
            } else {
                positions[i] = -5
            }
        }
        const geometry = new THREE.BufferGeometry()
        geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
        
        const material = new THREE.MeshBasicMaterial({color:'white'})
        const mesh = new THREE.Mesh(geometry, material)

        this.meshes.push(mesh)



        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Sphere')
        }

        this.particles= {}
        this.particles.positions = []
        this.particles.maxCount = 0;
        this.particles.index = 0;
        this.particles.currentIndex = 0;

  

        this.setMap()

        this.toLoad = this.regions.length;
        this.load = 0




}


    async setMap() {



        const createInstanceDots = (count) => {

            // this.particles.positions.push(count)

                

            const particlesGeometry = new THREE.BufferGeometry();
            const positions = new Float32Array(count.length);
            const colors = new Float32Array(count.length);
    
    
    
            for (let i = 0; i < count.length; i++) {
                positions[i] = count[i];
            }
    
            particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
            // particlesGeometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
            // particlesGeometry.computeVertexNormals()
            const particlesMaterial = new THREE.MeshBasicMaterial();

    

            // const geomtry = new THREE.BufferGeometry(positions)
            const particles = new THREE.Mesh(particlesGeometry, particlesMaterial);

            // this.group.add(particles);
            // this.group.visible = false

            this.meshes.push(particles);

            this.load++

            if(this.toLoad === this.load){
                this.setParticles()
            }

        }


        for (const re of this.regions){
            const dotCount = await new ImageWorker(re, this.context, this.imageCanvas).processImage()

            createInstanceDots(dotCount);

        }

        // const seCount = await new ImageWorker('se', this.context, this.imageCanvas).processImage()

        // const seCount = await new ImageWorker('se', this.context, this.imageCanvas).processImage()
        // const seCount = await new ImageWorker('se', this.context, this.imageCanvas).processImage()
        // const seCount = await new ImageWorker('se', this.context, this.imageCanvas).processImage()



    }
    setParticles() {

        const positions = this.meshes.map(child => child.geometry.attributes.position)

        for(const position of positions){
            
            if(position.count > this.particles.maxCount){
                this.particles.maxCount = position.count
            }
        }

     

        
        for(const position of positions){
            const originalArray = position.array

            const newArray = new Float32Array(this.particles.maxCount * 3)



            for(let i=0; i<this.particles.maxCount; i++){
                const i3 = i * 3;

                if(i3 < originalArray.length){
                    newArray[i3 + 0] = originalArray[i3 + 0]
                    newArray[i3 + 1] = originalArray[i3 + 1]
                    newArray[i3 + 2] = originalArray[i3 + 2]
                }
                else {
                    const randomIndex = Math.floor(position.count * Math.random()) * 3
                    newArray[i3 + 0] = originalArray[randomIndex + 0]
                    newArray[i3 + 1] = originalArray[randomIndex + 1]
                    newArray[i3 + 2] = originalArray[randomIndex + 2]

                    // newArray[i3 + 0] = 0
                    // newArray[i3 + 1] = 0
                    // newArray[i3 + 2] = 0
                }


            }


            this.particles.positions.push(new THREE.Float32BufferAttribute( newArray, 3))


        }   


        const sizesArray = new Float32Array(this.particles.maxCount)

        for(let i =0; i< this.particles.maxCount; i++){
            // sizesArray[i] = Math.random() + 0.2
            sizesArray[i] = Math.random()
            // sizesArray[i] = 0.7

        }


        

        // // Geometry
        this.particles.geometry = new THREE.BufferGeometry()
        this.particles.geometry.setAttribute('position', this.particles.positions[0])
        this.particles.geometry.setAttribute('aPositionTarget', this.particles.positions[1])
        this.particles.geometry.setAttribute('aSize', new THREE.BufferAttribute(sizesArray, 1))




        this.particles.colorA = '#0387FC'
        this.particles.colorB = '#ffffff'

        // Material
        this.particles.material = new THREE.ShaderMaterial({

            vertexShader: particlesVertexShader,
            fragmentShader: particlesFragmentShader,
            vertexColors: true,
            uniforms:
            {
                uSize: new THREE.Uniform(0.7),
                aSize: new THREE.Uniform(1.0),
                uResolution: new THREE.Uniform(new THREE.Vector2(this.sizes.width * this.sizes.pixelRatio, this.sizes.height * this.sizes.pixelRatio)),
                uProgress: new THREE.Uniform(0.0),
                uColorA : new THREE.Uniform(new THREE.Color(this.particles.colorA)),
                uColorB : new THREE.Uniform(new THREE.Color(this.particles.colorB)),
                uColorProgress : new THREE.Uniform(0.0),
            },

        })


        this.particles.points = new THREE.Points(this.particles.geometry, this.particles.material)

        this.scene.add(this.particles.points)
       
        this.scaleTl
        .to(this.particles.material.uniforms.aSize, {value: 0.0})
        .to(this.particles.points, {visible: false})

        this.particles.morph = index => {

            if(this.particles.index === index){
                return null
            }

            gsap.to(".country__name", {opacity:0.4, autoAlpha:1})

            this.particles.geometry.attributes.position = this.particles.positions[this.particles.index]
            this.particles.geometry.attributes.aPositionTarget = this.particles.positions[index]

            gsap.fromTo(this.particles.material.uniforms.uProgress, {value:0}, {value:1, duration:1, ease:'power4.inOut'})
            this.particles.index = index


        }

        this.particles.morph0 = () => {this.particles.morph(0)}
        this.particles.morph1 = () => {this.particles.morph(1)}
        this.particles.morph2 = () => {this.particles.morph(2)}
        this.particles.morph3 = () => {this.particles.morph(3)}
        this.particles.morph4 = () => {this.particles.morph(4)}
        this.particles.morph5 = () => {this.particles.morph(5)}
        this.particles.morph6 = () => {this.particles.morph(6)}
        this.particles.morph7 = () => {this.particles.morph(7)}
        this.particles.morph8 = () => {this.particles.morph(8)}
        this.particles.morph9 = () => {this.particles.morph(9)}
        this.particles.morph10 = () => {this.particles.morph(10)}
        this.particles.morph11 = () => {this.particles.morph(11)}
        this.particles.morph12 = () => {this.particles.morph(12)}

    }


   
    play(){
        this.scaleTl.play()
      }
  
      reverse(){
        this.scaleTl.reverse()
      }
  

    
}